import { useTranslations } from 'next-intl';

import { type BrandBySlugResponse } from '@/modules/brands/aliases';

export function useBrandBreadcrumbs(brand?: BrandBySlugResponse) {
  const t = useTranslations('common');

  if (!brand?.name || !brand.slug) {
    return [];
  }

  return [
    {
      label: t('Brands'),
      slug: 'brands',
      link: '/brands',
    },
    {
      label: brand.name,
      slug: brand.slug,
      link: `/brands/${brand.slug}`,
    },
  ];
}
